import { render } from "./HomeStatistics.vue?vue&type=template&id=008a3782"
import script from "./HomeStatistics.vue?vue&type=script&lang=js"
export * from "./HomeStatistics.vue?vue&type=script&lang=js"

import "./HomeStatistics.vue?vue&type=style&index=0&id=008a3782&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__